<template>
	<div class="iframe-container" :class="{ 'is-open': isOpen, 'is-on-left': isOnLeft, 'is-nudge-top': isNudgeTop }">
		<div class="top-action-bar flex-end--center">
			<OutlinedButton class="text-transform-none" @click="openDocs" x-small><DocSvg class="mr-2" /> {{ hoverButtonText }}</OutlinedButton>
		</div>
		<iframe :src="docsUrl" />
	</div>
</template>

<script>
import DocSvg from './assets/DocSvg';

export default {
	name: 'IFrameContainer',
	components: { DocSvg },
	props: {
		docsUrl: { type: String },
		isOpen: { type: Boolean },
		isOnLeft: { type: Boolean },
		isNudgeTop: { type: Boolean },
		hoverButtonText: { type: String, default: 'Open in a new tab' },
	},
	computed: {
		isButtonOnTheLeftSide() {
			const routes = ['Feature'];
			return routes.includes(this.$route.name);
		},
	},
	methods: {
		openDocs() {
			window.open(this.docsUrl, '_blank');
		},
	},
};
</script>

<style lang="scss" scoped>
@import './in-app-help-mixin.scss';
@import './in-app-help-menu-mixin.scss';

.iframe-container {
	iframe {
		height: calc(#{$menu-height} - 2 * #{$menu-pad});
		width: calc(#{$menu-width} - 2 * #{$menu-pad});
	}

	@include open-close-behaviour();
	@include in-app-help-menu-styles();
}
.text-transform-none {
	text-transform: none !important;
}
</style>
